import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Protected = ({ children, roles = [], requireApprovedDoctor = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireApprovedDoctor && user.role === 'DOCTOR' && user.doctorVerificationStatus !== 'APPROVED') {
    return <Navigate to="/doctor-verification" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (roles.length > 0 && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="max-w-md mx-auto text-center">
          <div className="bg-error-50 border border-error-200 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-error-800 mb-2">
              Access Denied
            </h2>
            <p className="text-error-600">
              You don't have permission to access this page.
            </p>
            <button 
              onClick={() => window.history.back()}
              className="mt-4 px-4 py-2 bg-primary text-white rounded-full hover:bg-primary-500 transition-colors"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default Protected;